<rb-loading-spinner *ngIf="dataLoading" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessage && !dataLoading">
    <rb-callout type="warning">
        No data for "Equivalent Full Cycles" chart.
    </rb-callout>
</div>
<div id="equivalent-full-charge-cycles"></div>
<div class="p-2" *ngIf="!dataLoading && !errorMessage">
    <div class="shaded-container ">
        Distribution of the number of equivalent full cycles across the fleet. This sets the charged energy in relation to the battery's capacity and enables thereby a better comparison in a fleet of vehicles with different battery sizes. The values are given as a percentage of the whole fleet.
    </div>
</div>